import React from 'react';
import SubView from 'components/main/pages/home/views/SubView';
import MemoryGameRankingRow from 'components/main/items/rows/MemoryGameRankingRow';

class MemoryGameRanking extends SubView {

  constructor(props){
    super(props);
    this.init(props);
    this.getMemoryGameRanking();
  }

  getMemoryGameRanking(){
    this.memoryGameId = this.store.memoryGames.viewingMemoryGamePublish._id;
    this.ranking = this.store.memoryGames.rankings[this.memoryGameId];
    this.actions.memoryGames.getRanking(this.memoryGameId);
  }

  rankingList(ranking){
    return ranking.map((data,i)=>{
      return <MemoryGameRankingRow key={i} app={this.app} data={data} index={i}/>
    })
  }

  render(){
    this.memoryGameId = this.store.memoryGames.viewingMemoryGamePublish._id;
    this.ranking = this.store.memoryGames.rankings[this.memoryGameId];

    return(
      <div style={this.subViewStyle()}>
        {this.ranking && this.rankingList(this.ranking)}
      </div>
    )
  }



}

export default MemoryGameRanking;
